import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", () => {
    const hero = document.querySelector('.hero');
    const heroSlider = hero.querySelector('.hero__slider');
    const exploreBtn = hero.querySelector('.explore-button-wrapper');
    const nextSection = hero.nextElementSibling;
    

    // hero slider
    if( hero && heroSlider ) {
        var splide = new Splide( '.hero__slider' , {
            type: 'fade',
            rewind: true,
            speed: 4000,
            interval: 7000,
            autoplay: true,
            arrows: false,
            pagination: false,
            perPage: 1,
            perMove: 1
        });
        splide.mount();
    }

    if( exploreBtn ) {
        exploreBtn.addEventListener('click', () => {
            if (nextSection) {
                nextSection.scrollIntoView({ 
                    behavior: 'smooth'
                });
            }
        })
    }
});